import React from 'react';

import {
  createExpiringDocumentsSettingRequest,
  deleteExpiringDocumentsSettingRequest,
  getExpiringDocumentsSettingsRequest,
  updateExpiringDocumentsSettingRequest,
} from '@vyce/core/src/api/companies';
import { TeamsSettingsView } from '@vyce/core/src/views/teams/TeamsSettings';

import { useTypedSelector } from 'src/hooks';

export const TeamsSettingsPage: React.FC = () => {
  const { selectedCompany, selectedCompanyAppData } = useTypedSelector(state => state.helper);

  return (
    <TeamsSettingsView
      companyId={selectedCompany?.uuid}
      teams={selectedCompanyAppData?.teams ?? []}
      getSettings={getExpiringDocumentsSettingsRequest}
      createSetting={createExpiringDocumentsSettingRequest}
      updateSetting={updateExpiringDocumentsSettingRequest}
      deleteSetting={deleteExpiringDocumentsSettingRequest}
    />
  );
};
